
import { Navigate, Outlet } from "react-router-dom";
const UserProtected = () => {
  const isAuth = localStorage.getItem("userId");
  if (!isAuth) {
    return <Navigate to="/login" />;
  } else {
    return <Outlet />;
  }
};
export default UserProtected;
